/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  REQUEST_METRIC_TYPES,
  FETCH_METRIC_TYPES_SUCCESS,
  FETCH_METRIC_TYPES_FAILURE,
  SELECT_METRIC_TYPE,
  SELECT_ALL_METRIC_TYPES,
  SELECT_METRIC_TYPE_GROUP,
} from "./actionTypes";

export function requestMetricTypes() {
  return {
    type: REQUEST_METRIC_TYPES,
  };
}

export function fetchMetricTypes(getMetricTypes) {
  return (dispatch) => {
    dispatch(requestMetricTypes());
    return getMetricTypes().then((json) =>
      dispatch(fetchMetricTypesSuccess(json))
    );
  };
}

export function fetchMetricTypesSuccess(json) {
  return {
    type: FETCH_METRIC_TYPES_SUCCESS,
    data: json,
  };
}

export function fetchMetricTypesFailure(error) {
  return {
    type: FETCH_METRIC_TYPES_FAILURE,
    errorMessage: error.message,
  };
}

export function selectMetricType(metricTypeId, metricId, selected) {
  return {
    type: SELECT_METRIC_TYPE,
    metricTypeId,
    metricId,
    selected,
  };
}

export function selectAllMetricTypes(deviceId, selected) {
  return {
    type: SELECT_ALL_METRIC_TYPES,
    deviceId,
    selected,
  };
}

export function selectMetricTypeGroup(metricTypeGroup, selected) {
  return {
    type: SELECT_METRIC_TYPE_GROUP,
    metricTypeGroup,
    selected,
  };
}
